import common from './common'
import { REPORT_PARAMS, SDK_PRODUCT } from '@/config/dataMap'
const changeUserInfoKfmt = 'duba_newvip_account:6252 version:byte vip_version:int click:byte operation:byte img_id:byte openid:string result:byte reason:string product_id:int'

const vip_version = REPORT_PARAMS.vip_version
const report_version = REPORT_PARAMS.report_version

export default {
  API: {
    method1 () {
    }
  },
  REPORT: {
    reportChangeUserInfo (params) {
      const info = {
        version: report_version,
        vip_version,
        click: 0,
        operation: 0,
        img_id: 0,
        openid: '',
        result: 1,
        reason: '',
        product_id: SDK_PRODUCT.id
      }
      return common.REPORT.client_report_by_kfmt(changeUserInfoKfmt, common.API.replaceObj(info, params))
    }
  }
}
